<template>
  <div class="group-card">
    <div class="group__top">
      <h4 class="group-card__title">{{ name }}</h4>
      <div class="group-card__description">{{ description }}</div>
    </div>
    <div class="group__bottom">
      <div class="group-card__members h4">
        {{ members }}
        <span v-if="members === 0 || members > 4">Участников</span>
        <span v-else-if="members === 1">Участник</span>
        <span v-else-if="members > 1 && members < 5">Участника</span>
      </div>
      <div class="group-card__actions">
        <vs-button
          type="flat"
          size="large"
          icon-pack="feather"
          icon="icon-edit"
          :to="{name: 'groups_edit', params: {groupSlug: slug}}"
        />
        <vs-button
          type="flat"
          size="large"
          icon-pack="feather"
          icon="icon-trash-2"
          @click.prevent="$emit('delete', slug)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slug: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    members: {
      type: Number
    }
  }
}
</script>

<style lang="scss">
.group-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  border-radius: .5rem;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  padding: 3rem 1.5rem;
  min-height: 360px;
  height: 100%;
  transition: .3s ease-in-out;
  &:hover {
    transform: scale(.99);
    box-shadow: none;
  }
  &__title {
    margin-bottom: 15px;
  }
  &__description {
    margin-bottom: 15px;
  }
  &__members {
    margin-bottom: 80px;
  }
  &__actions {
    display: flex;
    align-items: center;
  }
}
</style>
